(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('file-manager', {
            parent: 'admin',
            url: '/file-manager',
            data: {
                pageTitle: 'file-manager.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/file-manager/file-manager.html',
                    controller: 'FileManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file-manager');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
